'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function QuickQuoteWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  if (!isHydrated) {
    return null;
  }

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 right-6 w-14 h-14 bg-accent hover:bg-accent/90 text-accent-foreground rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 z-40"
        aria-label="Ouvrir le widget de devis rapide"
      >
        <Icon name="CalculatorIcon" size={24} />
      </button>

      {isOpen && (
        <div className="fixed inset-0 bg-foreground/50 flex items-center justify-center z-50 p-4">
          <div className="bg-card rounded-lg shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-primary text-primary-foreground px-6 py-4 flex items-center justify-between sticky top-0">
              <h3 className="text-lg font-heading font-bold flex items-center gap-2">
                <Icon name="DocumentTextIcon" size={20} />
                Devis Rapide
              </h3>
              <button
                onClick={() => setIsOpen(false)}
                className="w-8 h-8 flex items-center justify-center hover:bg-primary-foreground/20 rounded-lg transition-colors duration-300"
                aria-label="Fermer"
              >
                <Icon name="XMarkIcon" size={20} />
              </button>
            </div>

            <div className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Type de service
                </label>
                <select className="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent">
                  <option>Nettoyage résidentiel</option>
                  <option>Nettoyage commercial</option>
                  <option>Nettoyage spécialisé</option>
                  <option>Services de conciergerie</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Nom complet
                </label>
                <input
                  type="text"
                  placeholder="Jean Dupont"
                  className="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Email
                </label>
                <input
                  type="email"
                  placeholder="jean.dupont@example.com"
                  className="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Téléphone
                </label>
                <input
                  type="tel"
                  placeholder="+41 XX XXX XX XX"
                  className="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Surface approximative (m²)
                </label>
                <input
                  type="number"
                  placeholder="50"
                  className="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-foreground mb-2">
                  Message (optionnel)
                </label>
                <textarea
                  rows={3}
                  placeholder="Décrivez vos besoins..."
                  className="w-full px-4 py-2 border border-border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
                ></textarea>
              </div>

              <button className="w-full bg-primary hover:bg-secondary text-primary-foreground font-medium py-3 px-4 rounded-lg transition-colors duration-300 flex items-center justify-center gap-2">
                <Icon name="PaperAirplaneIcon" size={20} />
                Envoyer la demande
              </button>

              <p className="text-xs text-muted-foreground text-center">
                Nous vous répondrons dans les 24 heures
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}